'use client';
import { useStore } from '@/providers/app-store-provider';
import { ReportingCenter } from '@/reporting';
import { AwinProvider } from '@/reporting/providers/awinProvider';
import { ProviderType } from '@/reporting/types';
import logger from '@/utils/client-logger';
import { useEffect } from 'react';

/**
 * Awin 绑定初始化 Hook
 * 主要用于页面初始化时处理 Awin 参数绑定
 * - 游客用户：存储 awc 参数到 localStorage（30天）
 * - 登录用户：存储参数 + 调用 API 绑定（但用户登录后的绑定主要由 userSlice.ts 处理）
 */
export const useAwinBindInit = () => {
  const token = useStore((state) => state.token);
  const clientTokenReady = useStore((state) => state.clientTokenReady);
  const refreshAccountInfo = useStore((state) => state.refreshAccountInfo);

  useEffect(() => {
    if (!clientTokenReady) return;
    const handleAwinBinding = async () => {
      try {
        const center = ReportingCenter.getInstance();
        const awinProvider = center.getProvider(ProviderType.AWIN) as AwinProvider;

        if (awinProvider) {
          // 直接使用封装好的bindAwin方法，它会自动处理：
          // 1. 从URL参数或localStorage获取awc
          // 2. 设置30天过期时间（游客和登录用户都需要）
          // 3. 如果有token就调用后端API绑定（但用户登录后的绑定主要由userSlice.ts处理）
          // 4. 绑定成功后删除localStorage中的awc
          await awinProvider.bindAwin(
            token,
            token
              ? () => {
                  // 绑定成功后刷新账户信息
                  refreshAccountInfo();
                }
              : undefined,
          );
        }
      } catch (error) {
        logger.error('Failed to handle awin binding:', error);
      }
    };

    handleAwinBinding();
  }, [token, refreshAccountInfo, clientTokenReady]); // 依赖 token 和 refreshAccountInfo，确保 token 正确设置后再执行
};
